export enum TranCategory {
  TRADE = 'TRADE',
  TRANSFER = 'TRANSFER',
  CASH_ENTRY = 'CASH_ENTRY',
  FX_TRADE = 'FX_TRADE',
  CURRENCY_FORWARD = 'CURRENCY_FORWARD',
  DIRECT_TRANSFER = 'DIRECT_TRANSFER',
  OTHER = 'OTHER',
}

export enum TranCategoryBulk {
  TRADE = 'TRADE',
  TRANSFER_IN = 'TRANSFER_IN',
  TRANSFER_OUT = 'TRANSFER_OUT',
  LOAD = 'LOAD',
  CASH_ENTRY = 'CASH_ENTRY',
  FX_TRADE = 'FX_TRADE',
  CURRENCY_FORWARD = 'CURRENCY_FORWARD',
  DIRECT_TRANSFER = 'DIRECT_TRANSFER',
  OTHER = 'OTHER',
}

export enum TranCategoryUrl {
  TRADE_ENTRY = 'trade',
  TRANSFER = 'securityTransfer',
  CASH_ENTRY = 'cashEntry',
  FX_TRADE = 'fxTrade',
  CURRENCY_FORWARD = 'fxForward',
  DIRECT_TRANSFER = 'directTransfer',
}
